import { ApplicationContext } from '@upside/spa-shared-context';

import { paths } from 'shell/const';
import { registerApplication } from 'single-spa';

export const registerLogout = (context: ApplicationContext): void => {
  registerApplication<ApplicationContext>({
    name: 'logout',
    app: {
      bootstrap: () => Promise.resolve(),
      mount: async () => {
        // Logout will emit StandardEvents.Logout event if successful
        // which triggers the redirect in event handlers
        await context.authentication.logout();
      },
      unmount: () => Promise.resolve(),
    },
    activeWhen: (location) => location.pathname.startsWith(`/${paths.LOGOUT}`),
  });
};
